
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ImpulsesService } from 'src/app/services/impulses.service';
import { MENU_ITEMS } from '../models/menu-items.list';
import { checkTimeRange } from '../utils/time-range';
import { environment } from 'src/environments/environment';
import { TabStateService } from 'src/app/services/tab-state.service';
import { ReportIssueDialogService } from 'src/app/services/report-issue-dialog.service';
import { TourService } from 'src/app/services/tour-service.service';
import { filter } from 'rxjs';
import { MatrisToastService } from 'src/app/matrisneocommon/matris-toast.service';
import { ToastMessageSeverity } from 'src/app/enums/ToastMessageSeverity.enum';
import { ToastMessage } from 'src/app/enums/ToastMessages.enum';
@Component({
  selector: 'neo-matris-menubar',
  templateUrl: './matris-menubar.component.html',
  styleUrls: ['./matris-menubar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MatrisMenubar {
  @Input() username: string = '';
  @Input() companyName: string = '';
  @Input() showAlert: boolean = false;
  showOrders: boolean = false;
  showProcurementHub: boolean = false;
  showTQDCS: boolean = false;
  showForecasting: boolean = false;
  showKickOffProtocol: boolean = false;
  showMATGTeam: boolean = false;
  showSourcingPlanning: boolean = false;
  showXring: boolean = false;
  items: any = [];
  messages: any[];
  bannerMessage: string = '';
  isBannerMessageVisible: boolean = false;
  version: string;
  showMenubarSkeleton: boolean = true;
  header: string = '';
  isFeedbackDialogVisible: boolean = false;



  closeFeedbackDialog() {
    this.isFeedbackDialogVisible = false;
  }

  constructor(private router: Router, private impulsesService: ImpulsesService,private toastService: MatrisToastService,
    private tabStateService: TabStateService, private reportDialogService: ReportIssueDialogService, private tourService: TourService) {
    this.version = environment.version ? environment.version : ''
    this.menubarStyle();
  }

  openFeedbackDialog() {
    //this.dialog.displayDialog = true;
    //this.isFeedbackDialogVisible = true;
    this.reportDialogService.setShowReportIssueDialogStatus(true);
  }
  // onFeedbackClick(op: any) {
  //   op.hide();
  //   setTimeout(() => {
  //     this.openFeedbackDialog();
  //   }, 0);
  // }

  onFeedbackClick() {
  this.openFeedbackDialog();
}

  onEditProfileClick(){
    this.router.navigate(['/user-profile']);
  }

  tourTooltip: string = "Take a tour of this page";
  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const parsedUrl = this.router.parseUrl(this.router.url);
        const currentPath = '/' + (parsedUrl.root.children['primary']?.segments.map(s => s.path).join('/') || '');
        switch (currentPath) {
          case '/impulses/list':
          case '/orders/overview':
            this.tourTooltip = 'Take a tour of this page';
            break;
          case '/':
            this.tourTooltip = 'Take a tour of Matris Neo';
            break;
          default:
            this.tourTooltip = 'Take a tour of this page';
            break;
        }
        this.tourService.setTooltipText(this.tourTooltip);
      });
  }
  ngAfterViewInit() {

  }

  menubarStyle() {

    document.documentElement.style.setProperty(
      '--menubar-color',
      environment.menubar || 'rgb(0, 29, 33)'
    );

    document.documentElement.style.setProperty(
      '--menubar-hover-color',
      environment.hover || 'rgb(0, 29, 33)'
    );

  }

setMenubarItems() {
  // Set theme colors
  document.documentElement.style.setProperty('--menubar-color', environment.menubar || '#041e42');
  document.documentElement.style.setProperty('--menubar-hover-color', environment.hover || 'rgb(0, 29, 33)');

  // Set header
  this.header = environment.production ? '' : 'DEV';
    this.impulsesService.getFeatureFlag().subscribe({
      next: (data) => {
        const response = data as any;
        if (response) {
          // Banner setup
          const start = response.generalConfig.banner.startTime;
          const end = response.generalConfig.banner.endTime;
          const showBanner = response.generalConfig.banner.isVisible && checkTimeRange(start, end);
          this.isBannerMessageVisible = !!showBanner;
          this.bannerMessage = response.generalConfig.banner.message || 'Please close this message. There seems to be some issue fetching the message content.';
          this.messages = [{ severity: 'info', detail: this.bannerMessage }];

          // Reset menu
          this.items = [...MENU_ITEMS];
          this.showOrders = !!response.featureFlagConfig.showOrders?.enabled;
          this.showProcurementHub = !!response.featureFlagConfig.showProcurementStartegyHub?.enabled;
          this.showTQDCS = !!response.featureFlagConfig.showTQDCS?.enabled;
          this.showForecasting = !!response.featureFlagConfig.showForecasting?.enabled;
          this.showKickOffProtocol = !!response.featureFlagConfig.showKickOffProtocol?.enabled;
          this.showMATGTeam = !!response.featureFlagConfig.showMATGTeam?.enabled;
          this.showSourcingPlanning = !!response.featureFlagConfig.showSourcingPlanning?.enabled;
          this.showXring = !!response.featureFlagConfig.showXring?.enabled;


          if (this.showOrders) {
            this.addMenuItem({
              label: 'Order Management',
              routerLink: 'orders',
              command: () => {
                if (MENU_ITEMS.find(e => e.label === 'Procurement Strategy Hub')) {
                  MENU_ITEMS[4].routerLink = "";
                }
              }
            });
          }

          this.checkProcurementTab();

          // Save to localStorage with expiry (e.g. 24 hours)
          const menuToStore = {
            items: this.items,
            expiry: Date.now() + 1000 * 60 * 60 * 24 // 24 hours
          };
          localStorage.setItem('menuItems', JSON.stringify(menuToStore));

          this.showMenubarSkeleton = false;
        }
      },
      error: () => {
        this.items = [...MENU_ITEMS];
        this.showMenubarSkeleton = false;
      }
    });
}


onGuidedTourBtnClick() {
  const currentPath = this.router.parseUrl(this.router.url).root.children['primary']?.segments
    .map(s => s.path)
    .join('/') || '';
  const path = '/' + currentPath;

  if (path === "/") {
    this.tourService.addIntroStep();
    this.tourService.startMenubarTour();
  } else {
    this.tourService.triggerTourPath(path);
  }

  if (path === "/impulses/list") {
    localStorage.setItem(this.tourService.IMPULSES_TOUR_KEY, 'false');
    localStorage.setItem(this.tourService.MENUBAR_TOUR_KEY, 'false');
    this.tourService.startImpulseTour(() => {});
  } else if (path === "/") {
    localStorage.setItem(this.tourService.MENUBAR_TOUR_KEY, 'false');
    localStorage.setItem(this.tourService.IMPULSES_TOUR_KEY, 'false');
    this.tourService.startMenubarTour();
  } else if (path === "/orders/overview") {
    localStorage.setItem(this.tourService.MENUBAR_TOUR_KEY, 'false');
    localStorage.setItem(this.tourService.IMPULSES_TOUR_KEY, 'false');
    this.tourService.startOrdersTour();
  } else if (path === "/orders/create-new-order") {
    localStorage.setItem(this.tourService.MENUBAR_TOUR_KEY, 'false');
    localStorage.setItem(this.tourService.IMPULSES_TOUR_KEY, 'false');
    this.tourService.startCreateOrderTour();
  } else if (path === "/part-package/list") {
    localStorage.setItem(this.tourService.VIEW_PACKAGE_TOUR_KEY, 'false');
    this.tourService.startViewPackagesTour();
  } else if (path === "/part-package/create-package") {
    localStorage.setItem(this.tourService.CREATE_PACKAGE_TOUR_KEY, 'false');
    this.tourService.startCreatePackageTour();
  } else if (path === "/find-your-colleague") {
    localStorage.setItem(this.tourService.FYC_TOUR_KEY, 'false');
    this.tourService.startFYCTour();
  }

  else if (path.startsWith("/details/")) {
    const selectedTab = this.tabStateService.getSelectedTabIndex();

    const activeTours = document.querySelectorAll('.shepherd-modal-overlay-container, .shepherd-element');
    activeTours.forEach(el => el.remove());
    window.dispatchEvent(new CustomEvent('startDetailsTour', { detail: { tab: selectedTab , manual: true } }));
  }

  else if (path === "/part-view/assigned-part-overview") {
    localStorage.setItem(this.tourService.ASSIGNED_PART_TOUR_KEY, 'false');
    this.tourService.startAssignedPartTour();
  }
}



  checkProcurementTab() {
    if (!this.showProcurementHub) return;
    const hubLabel = 'Strategy & Commercial Hub';
    const baseLink = '/strategy-commercial-hub';

      let hubItems = [];

  if (this.showTQDCS) {
    hubItems = [
      { label: 'MATG Team', routerLink: `${baseLink}/matg-team` },
      { label: 'TQDCS', routerLink: `${baseLink}/tqdcs` },
      { label: 'Sourcing Planning', routerLink: `${baseLink}/sourcing-planning` },
      { label: 'X Ring', routerLink: `${baseLink}/x-ring-team/:team` },
      { label: 'Forecasting', routerLink: `${baseLink}/forecasting-overview` },
      { label: 'Kick-off Protocol', routerLink: `${baseLink}/kickoff-protocol` },
      { label: 'Nomination Letter', routerLink: `${baseLink}/nomination-overview` }
    ];
  } else {
    hubItems = [
      { label: 'MATG Team', routerLink: `${baseLink}/matg-team` }
    ];
  }

    const existingIndex = MENU_ITEMS.findIndex(item => item.label === hubLabel);
    if (existingIndex !== -1) {
      MENU_ITEMS.splice(existingIndex, 1);
    }
    // Add parent menu item WITHOUT routerLink, only children
    this.addMenuItem({
      label: hubLabel,
      items: hubItems
    });
    const menuData = {
      items: [...MENU_ITEMS],
      expiry: Date.now() + 1000 * 60 * 60 * 24 // expires in 24 hours
    };
    localStorage.setItem('menuItems', JSON.stringify(menuData));
}

  addMenuItem(newItem: any) {
    this.items.push(newItem);
  }



  goToHome() {
    this.router.navigate(['/']);
  }

  redirectToHomePage() {
    this.router.navigate(['/']);
  }

}

